function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.842 0.419a1.436 1.436 0 0 0 -0.825 0.263 1.232 1.232 0 0 0 -0.292 1.598c1.323 2.292 1.84 5.117 1.148 7.299 -0.146 0.458 -0.483 0.669 -0.846 0.69a1.178 1.178 0 0 1 -1.078 -0.613 7.877 7.877 0 0 1 -0.427 -0.831 0.821 0.821 0 0 0 -1.15 -0.386 6.949 6.949 0 0 0 -3.575 6.253l0 0.011c0.09 2.218 0.854 4.206 2.351 5.642 1.5 1.438 3.647 2.236 6.348 2.236 2.711 0 4.856 -0.846 6.35 -2.3 1.487 -1.451 2.254 -3.434 2.349 -5.574 0.22 -5.093 -3.355 -11.18 -9.662 -14.112A1.436 1.436 0 0 0 9.841 0.421Z",
  clipRule: "evenodd",
  strokeWidth: 1
});

function SvgFire(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "-0.5 -0.5 24 24",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.7366d425.svg";
export { ForwardRef as ReactComponent };